import { TestType } from '@/types/RequisitionFormTypes'
import {
  getActiveUiConfig,
  getCliaLabId,
  getLabName,
  getTestTypeConfig as getTestTypeConfigFromUi,
  getTestTypesGroupedByCategory as getTestTypesGroupedByCategoryFromUi,
  LOGIN_FALLBACK_UI_CONFIG,
  type UiTestTypeOption,
} from './uiConfig'

export type TestTypeOption = UiTestTypeOption

/**
 * Non-React callers (canonical-order builder, Epic callback) read the
 * already-loaded :func:`getActiveUiConfig`. ``LOGIN_FALLBACK_UI_CONFIG``
 * (empty ``testTypes``) is only used when no config has been loaded yet —
 * authenticated routes should never hit this path because
 * :class:`UiConfigProvider` blocks rendering until ``status: 'ready'``.
 */
const activeOrFallback = () => getActiveUiConfig() ?? LOGIN_FALLBACK_UI_CONFIG

export function getTestTypesForOrganization(): TestTypeOption[] {
  return activeOrFallback().testTypes
}

export function getTestTypesGroupedByCategory(): Map<string, TestTypeOption[]> {
  return getTestTypesGroupedByCategoryFromUi(activeOrFallback())
}

export function getTestTypeConfig(testType: TestType): TestTypeOption | undefined {
  return getTestTypeConfigFromUi(testType, activeOrFallback())
}

export function getLabNameForOrganization(): string {
  return getLabName(activeOrFallback())
}

export function getCliaLabIdForOrganization(): string {
  return getCliaLabId(activeOrFallback())
}
